module.exports = __webpack_public_path__ + "efcac003a1ca030ba03cec52a91fdd65.svg";